import { createSlice } from '@reduxjs/toolkit';

const parseFeatureArray = (features) => {
    const result = {};
    if (Array.isArray(features)) {
        features.forEach(f => {
            // PascalCase → camelCase: IsExamineticsEnabled → isExamineticsEnabled
            const key = f.Name.charAt(0).toLowerCase() + f.Name.slice(1);
            // Auto-parse booleans
            if (f.Value === 'True') {
                result[key] = true;
            } else if (f.Value === 'False') {
                result[key] = false;
            } else {
                result[key] = f.Value;
            }
        });
    }
    return result;
};

const tenantFeaturesSlice = createSlice({
    name: 'tenantFeatures',
    initialState: {
        features: {},
        loaded: false,
    },
    reducers: {
        setTenantFeatures(state, action) {
            state.features = parseFeatureArray(action.payload);
            state.loaded = true;
        },
    },
});

export const { setTenantFeatures } = tenantFeaturesSlice.actions;
export default tenantFeaturesSlice.reducer;
